var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-indicator",class:_vm.state},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"device-indicator__description"},[_vm._t("description")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }